import React, { Component } from "react";
import {
  DataGrid,
  Column,
  Paging,
  Pager,
  Lookup,
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import notify from "devextreme/ui/notify";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarAdnNfeDs } from "../../DataSources";
import memoria from "../../Memoria";
import AdnNfeXmlPopup from "./AdnNfeXmlPopup";

const urlConsultaPublica = "https://www.nfse.gov.br/consultapublica";

const situacoesFiscais = [
  { id: 0, descricao: "Não informado" },
  { id: 1, descricao: "Emitida" },
  { id: 2, descricao: "Cancelada" },
  { id: 3, descricao: "Substituída" },
  { id: 4, descricao: "Bloqueada" },
];

const filtroVazio = () => ({
  prestadorCpfCnpj: "",
  prestadorNome: "",
  tomadorCpfCnpj: "",
  tomadorNome: "",
  chaveAcesso: "",
  numeroNf: null,
});

export default class AdnNfeBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.state = {
      filtro: filtroVazio(),
      popupXml: { visible: false, prefeituraId: undefined, nsu: undefined, chaveAcesso: "" },
    };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.copiarChave = this.copiarChave.bind(this);
    this.abrirXml = this.abrirXml.bind(this);
    this.fecharXml = this.fecharXml.bind(this);
    this.abrirConsultaPublica = this.abrirConsultaPublica.bind(this);
    this.adnNfeDs = criarAdnNfeDs();
  }

  componentDidMount() {
    memoria.redirecionarSeNecessario(this.props.location, this.props.history);
  }

  filtrar(e) {
    let filtro = this.state.filtro;

    let filtroCorrente = [];

    if (filtro.prestadorCpfCnpj !== undefined && filtro.prestadorCpfCnpj !== "" && filtro.prestadorCpfCnpj !== null) {
      let cpfCnpj = filtro.prestadorCpfCnpj.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      filtroCorrente.push(["prestadorCpfCnpj", "contains", cpfCnpj]);
    }
    if (filtro.prestadorNome !== undefined && filtro.prestadorNome !== "" && filtro.prestadorNome !== null) {
      filtroCorrente.push(["prestadorNome", "contains", filtro.prestadorNome.trim()]);
    }
    if (filtro.tomadorCpfCnpj !== undefined && filtro.tomadorCpfCnpj !== "" && filtro.tomadorCpfCnpj !== null) {
      let cpfCnpj = filtro.tomadorCpfCnpj.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      filtroCorrente.push(["tomadorCpfCnpj", "contains", cpfCnpj]);
    }
    if (filtro.tomadorNome !== undefined && filtro.tomadorNome !== "" && filtro.tomadorNome !== null) {
      filtroCorrente.push(["tomadorNome", "contains", filtro.tomadorNome.trim()]);
    }
    if (filtro.chaveAcesso !== undefined && filtro.chaveAcesso !== "" && filtro.chaveAcesso !== null) {
      let chave = filtro.chaveAcesso.replace(/\s/g, "").toUpperCase();
      filtroCorrente.push(["chaveAcesso", "=", chave]);
    }
    if (filtro.numeroNf !== undefined && filtro.numeroNf !== "" && filtro.numeroNf !== null) {
      filtroCorrente.push(["numeroNf", "=", filtro.numeroNf]);
    }

    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  limparFiltro(e) {
    this.setState({ filtro: filtroVazio() }, () => this.filtrar());
  }

  copiarChave(e) {
    navigator.clipboard.writeText(e.row.data.chaveAcesso);
    notify("Chave copiada. Cole na Consulta Pública NFS-e.", "success");
  }

  abrirXml(e) {
    this.setState({
      popupXml: {
        visible: true,
        prefeituraId: e.row.data.prefeituraId,
        nsu: e.row.data.nsuNfse,
        chaveAcesso: e.row.data.chaveAcesso,
      },
    });
  }

  fecharXml() {
    this.setState({
      popupXml: { visible: false, prefeituraId: undefined, nsu: undefined, chaveAcesso: "" },
    });
  }

  abrirConsultaPublica() {
    window.open(urlConsultaPublica, "_blank", "noopener");
  }

  render() {
    const popupXml = this.state.popupXml;

    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form onSubmit={this.filtrar}>
            <Form id="frmPesquisa" formData={this.state.filtro} colCount={6} labelLocation="top">
              <SimpleItem dataField="prestadorCpfCnpj">
                <Label text="CPF/CNPJ prestador" />
              </SimpleItem>
              <SimpleItem dataField="prestadorNome">
                <Label text="Prestador" />
              </SimpleItem>
              <SimpleItem dataField="tomadorCpfCnpj">
                <Label text="CPF/CNPJ tomador" />
              </SimpleItem>
              <SimpleItem dataField="tomadorNome">
                <Label text="Tomador" />
              </SimpleItem>
              <SimpleItem dataField="chaveAcesso">
                <Label text="Chave de acesso" />
              </SimpleItem>
              <SimpleItem
                dataField="numeroNf"
                editorType={"dxNumberBox"}
                editorOptions={{ step: 0 }}
              >
                <Label text="Número" />
              </SimpleItem>
            </Form>
            <br />
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Limpar Filtro" onClick={this.limparFiltro} />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  text="Consulta pública NFS-e"
                  icon="globe"
                  onClick={this.abrirConsultaPublica}
                />
              </div>
            </div>
          </form>
          <br /> <br />
          <PaginaToolbar titulo="Notas do ADN" ocultarNovo={true}>
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.adnNfeDs}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              focusedRowEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
            >
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  {
                    hint: "Copiar chave de acesso",
                    icon: "copy",
                    onClick: this.copiarChave,
                  },
                  {
                    hint: "Ver XML",
                    icon: "doc",
                    visible: (e) => e.row.data.nsuNfse != null,
                    onClick: this.abrirXml,
                  },
                ]}
              />
              <Column dataField={"numeroNf"} caption={"Número"} />
              <Column
                dataField={"dataEmissao"}
                caption={"Emissão"}
                dataType="date"
                format={uiInfo.formatoData.dataCurta}
                defaultSortOrder="desc"
              />
              <Column dataField={"situacaoFiscal"} caption={"Situação"}>
                <Lookup
                  dataSource={situacoesFiscais}
                  valueExpr="id"
                  displayExpr="descricao"
                />
              </Column>
              <Column dataField={"prestadorCpfCnpj"} caption={"CPF/CNPJ prestador"} />
              <Column dataField={"prestadorNome"} caption={"Prestador"} />
              <Column dataField={"tomadorCpfCnpj"} caption={"CPF/CNPJ tomador"} />
              <Column dataField={"tomadorNome"} caption={"Tomador"} />
              <Column
                dataField={"valorTotalNota"}
                caption={"Valor total"}
                format={uiInfo.formatoNumerico.moeda}
              />
              <Column
                dataField={"tributadaNoMunicipio"}
                caption={"Tributada no município"}
                dataType="boolean"
              />
              
              <Column dataField={"municipioPrestacao"} caption={"Município de prestação"} />

              <Column dataField={"chaveAcesso"} caption={"Chave de acesso"} visible={false} />
              <Column
                dataField={"valorIss"}
                caption={"Valor ISS"}
                format={uiInfo.formatoNumerico.moeda}
                visible={false}
              />
              <Column
                dataField={"issRetido"}
                caption={"ISS retido"}
                dataType="boolean"
                visible={false}
              />
              <Column dataField={"id"} caption={"Id"} visible={false} />
              <Column dataField={"nsuNfse"} caption={"NSU"} visible={false} />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={false}
              />
            </DataGrid>
          </PaginaToolbar>
          <AdnNfeXmlPopup
            visible={popupXml.visible}
            prefeituraId={popupXml.prefeituraId}
            nsu={popupXml.nsu}
            chaveAcesso={popupXml.chaveAcesso}
            onHiding={this.fecharXml}
          />
        </div>
      </React.Fragment>
    );
  }
}
